// extracted by mini-css-extract-plugin
export default {"container":"hawk-streaming-score-container","review-text":"hawk-streaming-score-review-text"};